var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_6972)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29.5,
    stroke: "url(#paint0_linear_1049_6972)",
    strokeWidth: 5,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1872 22.9602L7.96012 52.1872L7.96012 30.2669",
    stroke: "#7B8484",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2669 59.494L44.494 30.2669L44.494 52.1872",
    stroke: "url(#paint1_linear_1049_6972)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1049_6972",
    x1: 64,
    y1: -0.0000038147,
    x2: 0.0000038147,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1049_6972",
    x1: 20.747,
    y1: 64.9741,
    x2: 49.9741,
    y2: 35.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758080",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_6972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResult);
export default __webpack_public_path__ + "static/media/empty_result.6087139bcfe4f9aa75ea0515ca2a84a4.svg";
export { ForwardRef as ReactComponent };